import styled from 'styled-components';

const COLOR_MAP: Record<Color, string> = {
    black: 'rgba(0, 0, 0, 0.54)',
    orange: 'rgba(255, 152, 0, 1)',
    blue: 'rgba(24, 144, 255, 1)',
    red: 'rgba(207, 19, 34, 1)',
};

export type Color = 'black' | 'orange' | 'blue' | 'red';

type ColorListItem = {
    color: Color;
    render: React.ReactNode;
};

type ColorListProps = {
    items: ColorListItem[];
};

const ColorList = (props: ColorListProps) => {
    const { items = [] } = props;

    return (
        <Root>
            {items.map((item, idx) => (
                <Item key={idx} color={item.color}>
                    {item.render}
                </Item>
            ))}
        </Root>
    );
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    width: 120px;
`;

const Item = styled.p<{ color: Color }>`
    width: 100%;

    color: ${p => COLOR_MAP[p.color]};
    font-size: 1.2rem;
`;

export { ColorList };
